import {
  FETCH_WHITE_LABELLING,
  FETCH_WHITE_LABELLING_SUCCESS,
  FETCH_WHITE_LABELLING_FAILURE,
  UPDATE_WHITE_LABELLING,
  UPDATE_WHITE_LABELLING_SUCCESS,
  UPDATE_WHITE_LABELLING_FAILURE,
} from './constants';

import type { IWhiteLabellingState, IWhiteLabellingAction } from './types';

const initialState: IWhiteLabellingState = {
  loading: true,
  error: null,

  whiteLabellingConfig: {
    logoURL: '',
    faviconURL: '',
    navBarBackgroundColor: '',
    navBarFontColor: '',
    uiControlBackgroundColor: '',
    uiControlFontColor: '',
    showCheckboxBranding: true,
  },
  isWhiteLabellingConfigured: false,
};

const updateObject = (oldObject: IWhiteLabellingState, newValues: any) => ({
  ...oldObject,
  ...newValues,
});

function whiteLabellingReducer(
  state = initialState,
  action: IWhiteLabellingAction
) {
  switch (action.type) {
    case FETCH_WHITE_LABELLING:
      return updateObject(state, { loading: true, error: null });

    case FETCH_WHITE_LABELLING_SUCCESS: {
      localStorage.setItem(
        'whiteLabellingConfig',
        JSON.stringify(action.whiteLabellingConfig)
      );
      return updateObject(state, {
        whiteLabellingConfig: action.whiteLabellingConfig,
        isWhiteLabellingConfigured: action.isWhiteLabellingConfigured,
        loading: false,
      });
    }

    case FETCH_WHITE_LABELLING_FAILURE:
      return updateObject(state, { loading: false, error: action.error });

    case UPDATE_WHITE_LABELLING:
      return updateObject(state, { loading: true, error: null });

    case UPDATE_WHITE_LABELLING_SUCCESS: {
      const oldConfig = state.whiteLabellingConfig;
      const newConfig = { ...oldConfig, ...action.updatedWhiteLabellingConfig };
      return updateObject(state, {
        loading: false,
        whiteLabellingConfig: newConfig,
      });
    }

    case UPDATE_WHITE_LABELLING_FAILURE:
      return updateObject(state, { loading: false, error: action.error });

    default:
      return state;
  }
}

export default whiteLabellingReducer;
